import { GetDistance } from './GeoFunctions';

/** El pasajero sigue al conductor por tracking/{bookingId}; /locations solo sirve para buscarlo y para el panel. */
export const LOCATION_MIN_INTERVAL_MS = 14 * 1000;
export const LOCATION_MIN_DISTANCE_KM = 0.05;
/** Aunque el conductor esté quieto se reescribe `ts` para que no lo den por desconectado. */
export const LOCATION_HEARTBEAT_MS = 2 * 60 * 1000;
/** Ubicaciones con `ts` más viejo que esto no se ofrecen a pasajeros ni al despacho. */
export const LOCATION_STALE_MS = 10 * 60 * 1000;

/** last: { at, lat, lng } de la última escritura, o null. */
export const shouldWriteLocation = (last, next, now = Date.now()) => {
  if (!last) return true;
  const elapsed = now - last.at;
  if (elapsed >= LOCATION_HEARTBEAT_MS) return true;
  if (elapsed < LOCATION_MIN_INTERVAL_MS) return false;
  return GetDistance(last.lat, last.lng, Number(next.lat), Number(next.lng)) >= LOCATION_MIN_DISTANCE_KM;
};

/** Sin `ts` cuenta como reciente: las versiones anteriores de la app no lo guardan. */
export const isFreshLocation = (loc, now = Date.now()) => {
  const ts = Number(loc && loc.ts);
  return !(ts > 0) || now - ts <= LOCATION_STALE_MS;
};
